import { useState } from 'react';
import { fill, useCurrentOrgNode, useShellTexts } from '@portal/ui';

/** The MiCar logo, trimmed to the mark and wordmark, at 1×/2×/3× of its 40px header height. */
const LOGOS = `${import.meta.env.BASE_URL}logos`;
const HEADER_SRC = `${LOGOS}/micar-logo-h40.png`;
const HEADER_SRC_SET = `${LOGOS}/micar-logo-h40.png 1x, ${LOGOS}/micar-logo-h80.png 2x, ${LOGOS}/micar-logo-h120.png 3x`;

/**
 * The header's brand: the MiCar logo, and beside it the logo of the org node the portal is scoped
 * to (the node's own, else its tenant's — resolved by the backend), as the legacy header showed
 * the dealer's. A logo that fails to load is left out rather than drawn broken.
 */
export function Brand() {
  const t = useShellTexts().brand;
  const node = useCurrentOrgNode();
  return (
    <span className="flex min-w-0 items-center gap-3">
      <img
        src={HEADER_SRC}
        srcSet={HEADER_SRC_SET}
        width={149}
        height={40}
        alt={t.logoAlt}
        className="h-8 w-auto shrink-0"
      />
      {node?.logoUrl ? (
        <OrgLogo
          key={node.logoUrl}
          src={node.logoUrl}
          alt={fill(t.orgLogoAlt, { name: node.name })}
        />
      ) : null}
    </span>
  );
}

function OrgLogo({ src, alt }: { src: string; alt: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return null;
  }
  return (
    <>
      <span aria-hidden="true" className="h-7 w-px shrink-0 bg-line" />
      <img
        src={src}
        alt={alt}
        onError={() => setFailed(true)}
        className="h-8 max-w-[160px] min-w-0 object-contain"
      />
    </>
  );
}

/** The logo on the pre-login card (legacy: 150px wide). */
export function LoginLogo() {
  const t = useShellTexts().brand;
  return (
    <img
      src={`${LOGOS}/micar-logo-login-300w.png`}
      width={300}
      height={119}
      alt={t.logoAlt}
      className="h-auto w-[150px]"
    />
  );
}
